export default __webpack_public_path__ + "static/media/ColorfacilityMaster.80a4bd92.svg";